import ErrorPage from './error-page';
export default ErrorPage;


// WEBPACK FOOTER //
// ./src/universal/components/error-page/index.js